import React, { useEffect, useState } from 'react';
import api from '../lib/api';
import { useLang } from '../i18n/translations';
import { Clock, MapPin, Thermometer, Leaf, TrafficCone, Banknote, LogOut } from 'lucide-react';

const aqKey = (v) => (v <= 20 ? 'aq1' : v <= 40 ? 'aq2' : v <= 60 ? 'aq3' : v <= 80 ? 'aq4' : 'aq5');
const aqColor = (v) => (v <= 20 ? 'text-emerald-300' : v <= 40 ? 'text-lime-300' : v <= 60 ? 'text-yellow-300' : v <= 80 ? 'text-orange-300' : 'text-red-300');
const LOCALES = { bs: 'hr-HR', en: 'en-GB', de: 'de-DE', tr: 'tr-TR', ar: 'ar' };

export const TopInfoBar = () => {
  const { t, lang } = useLang();
  const [now, setNow] = useState(new Date());
  const [info, setInfo] = useState(null);

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    api.get('/travnik-info').then(({ data }) => setInfo(data)).catch(() => {});
    return () => clearInterval(id);
  }, []);

  const locale = LOCALES[lang] || 'hr-HR';

  const gateLogout = () => {
    localStorage.removeItem('eturizam_gate');
    localStorage.removeItem('eturizam_token');
    localStorage.removeItem('eturizam_user');
    window.location.href = '/';
  };
  const date = now.toLocaleDateString(locale, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Europe/Sarajevo' });
  const time = now.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit', second: '2-digit', timeZone: 'Europe/Sarajevo' });

  return (
    <div className="bg-[#001752] text-white/75 text-xs" data-testid="top-info-bar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-9 flex items-center justify-between gap-4">
        <div className="flex items-center gap-4 min-w-0">
          <span className="flex items-center gap-1.5 whitespace-nowrap font-semibold text-white"><MapPin className="h-3.5 w-3.5" /> Travnik</span>
          <span className="hidden lg:inline capitalize truncate" data-testid="info-date">{date}</span>
          <span className="flex items-center gap-1.5 font-semibold text-white tabular-nums" data-testid="info-clock">
            <Clock className="h-3.5 w-3.5" /> {time}
          </span>
        </div>
        <div className="flex items-center gap-4">
          {info?.temperature != null && (
            <span className="flex items-center gap-1 whitespace-nowrap" data-testid="info-temp">
              <Thermometer className="h-3.5 w-3.5" /> {Math.round(info.temperature)}°C
            </span>
          )}
          {info?.eur != null && info?.usd != null && (
            <span className="hidden lg:flex items-center gap-1.5 whitespace-nowrap tabular-nums" data-testid="info-fx">
              <Banknote className="h-3.5 w-3.5" /> 1 € = <b className="text-white">{info.eur.toFixed(2)} KM</b> · 1 $ = <b className="text-white">{info.usd.toFixed(2)} KM</b>
            </span>
          )}
          {info?.aqi != null && (
            <span className="hidden md:flex items-center gap-1.5 whitespace-nowrap" data-testid="info-aqi">
              <Leaf className="h-3.5 w-3.5" /> {t('airQuality')}: <b className={aqColor(info.aqi)}>{t(aqKey(info.aqi))} ({info.aqi})</b>
            </span>
          )}
          <a href="https://bihamk.ba/bs/informacije/stanje-na-putevima" target="_blank" rel="noreferrer" data-testid="info-roads"
            className="hidden sm:flex items-center gap-1.5 whitespace-nowrap text-white hover:text-white/70 transition-colors duration-200 underline underline-offset-2">
            <TrafficCone className="h-3.5 w-3.5" /> {t('roadInfo')}
          </a>
          <button onClick={gateLogout} title={t('gateLogout')} data-testid="gate-logout-btn"
            className="flex items-center gap-1.5 whitespace-nowrap text-white/70 hover:text-red-300 transition-colors duration-200 border-l border-white/20 pl-4">
            <LogOut className="h-3.5 w-3.5" /> <span className="hidden md:inline">{t('gateLogout')}</span>
          </button>
        </div>
      </div>
    </div>
  );
};
